(() => {
  if (window.__protacticNewColorsReady) return;
  window.__protacticNewColorsReady = true;

  class ProtacticNewColors {
    constructor(root) {
      this.root = root;
      this.slides = [...root.querySelectorAll('[data-pnc-slide]')];
      this.current = 0;
      this.interval = null;
      this.autoplay = root.dataset.autoplay === 'true';
      this.speed = Math.max(3000, Number(root.dataset.autoplaySpeed) || 6000);
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!this.slides.length) return;
      root.querySelectorAll('[data-pnc-prev]').forEach((button) => button.addEventListener('click', () => this.show(this.current - 1, true)));
      root.querySelectorAll('[data-pnc-next]').forEach((button) => button.addEventListener('click', () => this.show(this.current + 1, true)));
      root.querySelector('[data-pnc-viewport]')?.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.show(this.current + (event.key === 'ArrowRight' ? 1 : -1), true);
      });
      root.addEventListener('mouseenter', () => this.stop());
      root.addEventListener('mouseleave', () => this.start());
      root.addEventListener('focusin', () => this.stop());
      root.addEventListener('focusout', (event) => { if (!root.contains(event.relatedTarget)) this.start(); });
      this.show(0, false);
      this.start();
    }

    show(index, restart) {
      if (!this.slides.length) return;
      this.current = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, slideIndex) => {
        const active = slideIndex === this.current;
        slide.hidden = !active;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      this.root.querySelectorAll('[data-pnc-current]').forEach((node) => { node.textContent = String(this.current + 1).padStart(2, '0'); });
      this.root.style.setProperty('--pnc-progress', `${((this.current + 1) / this.slides.length) * 100}%`);
      if (restart) { this.stop(); this.start(); }
    }

    start() {
      if (!this.autoplay || this.reducedMotion || this.slides.length < 2 || this.interval) return;
      this.interval = window.setInterval(() => this.show(this.current + 1, false), this.speed);
    }

    stop() {
      window.clearInterval(this.interval);
      this.interval = null;
    }
  }

  const initialize = (scope = document) => scope.querySelectorAll?.('[data-pnc-carousel]').forEach((root) => {
    if (root.dataset.pncReady === 'true') return;
    root.dataset.pncReady = 'true';
    root.pncCarousel = new ProtacticNewColors(root);
  });

  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll?.('[data-pnc-carousel]').forEach((root) => root.pncCarousel?.stop()));
  document.addEventListener('shopify:block:select', (event) => {
    const slide = event.target.closest?.('[data-pnc-slide]');
    const root = slide?.closest('[data-pnc-carousel]');
    if (!slide || !root?.pncCarousel) return;
    root.pncCarousel.show(Number(slide.dataset.slideIndex), false);
    root.pncCarousel.stop();
  });
})();
